"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationFallback = void 0;
var _react = _interopRequireDefault(require("react"));
var _TipBox = _interopRequireDefault(require("../../../ui/TipBox"));
var _propTypes = require("prop-types");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var NotificationFallback = exports.NotificationFallback = function NotificationFallback(_ref) {
  var link = _ref.link,
    message = _ref.message,
    time = _ref.time;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      links: link,
      cta: link ? link.label : '',
      text: message
    },
    time: time
  });
};
NotificationFallback.propTypes = {
  link: _propTypes.string,
  message: _propTypes.string,
  time: _propTypes.string
};